<template>
    <ProgressBar />
    
    <ul class="kit-steps">
        <li>
            <header :class="{done: $store.state.step, active: $store.state.kitId}">
                <label>
                    <i class="fas fa-check"></i>
                </label>
                <strong>1. Kit Type</strong>
            </header>
        </li>

        <Step v-for="(step, key) in $store.state.current.groups" :key="key" :pos="key" :step="step" />

    </ul>

    <h3 v-if="$store.state.current && $store.state.current.discount" class="kit-discount__text">A discount will apply when ordering a product at each step.</h3>

    <Total />

</template>

<script>
    import ProgressBar from './components/info/Progress.vue';
    import Step from './components/info/Step.vue';
    import Total from './components/info/Total.vue';

    export default {
        name: 'InfoSidebar',
        components: {
            ProgressBar,
            Step,
            Total
        }
    }
</script>

<style lang="scss">
    .kit {
        &-steps {
            padding-top: 40px;

            > li {
                border: 1px solid #E5E7EC;
                background: #FFF;

                &:not(:last-child) {
                    margin-bottom: 10px;
                }

                header {
                    display: flex;
                    align-items: center;
                    position: relative;
                    padding: 10px;
                    gap: 8px;
                    color: #BFBFBF;
                    cursor: pointer;

                    &.done, &.active, &.pass {
                        color: #1d1e42;

                        figure {
                            display: block;
                        }
                    }

                    &.done {                        
                        label {
                            border-color: #F97623;
                            background-color: #F97623;
                            color: #fff !important;
                        }
                    }

                    &.active {
                        label {
                            border-color: #F97623;
                            color: #F97623;
                        }
                    }

                    &.pass.empty {
                        label {
                            border-color: #dc3545;
                            color: #fff;
                            background-color: #dc3545;
                        }
                    }

                    &.done.pass {
                        label {
                            border-color: #F97623;
                            background-color: #F97623;
                        }
                    }

                    label {
                        width: 18px;
                        height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 50%;
                        border: 2px solid #BFBFBF;
                        font-size: 10px;
                        color: #BFBFBF;
                    }

                    strong {
                        font-weight: 600;
                    }

                    figure {
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        translate: 0 -50%;
                        display: none;
                    }
                }
            }
        }

        &-discount {
            &__text {
                padding-top: 15px;
                line-height: 22px;
                font-weight: 500;
            }
        }
    }
</style>